// 其他应用

const routes = [
    {
        name: "督导半月报",
        path: "/monthlyReportCity",
        component: () => import( '@/views/monthlyReport/city.vue')
    },
    {
        name: "督导半月报",
        path: "/monthlyReportEare",
        component: () => import( '@/views/monthlyReport/eare.vue')
    },
    {
        name: "AI双师五育素养课",
        path: "/AITeacher",
        component: () => import( '@/views/AITeacher/index.vue')
    },
    {
        name: "机构注册",
        path: "/register",
        component: () => import( '@/views/register/index.vue')
    },
    {
        name: "cityCaseList",
        path: "/cityCaseList",
        component: () => import( '@/views/case/list.vue'),
        meta: { title: '市级“双减”案例', keepAlive: true,}
    },
    {
        name: "cityCaseContent",
        path: "/cityCaseContent",
        component: () => import( '@/views/case/content.vue'),
    },
];

export default routes;
